import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Badge,
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Row,
  Select,
  Spin,
  Table,
  Tooltip,
} from "antd";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import {
  getRequest,
  getRequest1,
  patchRequest,
  postRequest,
} from "../../axios";
import { authUserData } from "../../utils/Helper";
import { FilterFilled, InfoCircleOutlined } from "@ant-design/icons";
import { ReactComponent as RupeesSign } from "../../image/RupeesSign.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import ExelDownload from "../../image/exeldownload.svg";
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import "jspdf-autotable";
import jsPDF from "jspdf";
import Excel from "../../image/excel.png";
import PDF from "../../image/pdf.png";
import Downloadpd from "../../image/Downloadpd.svg";
import { DownloadTableExcel } from "react-export-table-to-excel";

const MaterialWiseComparativeByDiameter = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const navigate = useNavigate();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [hideUnitRateOfCementR0, setHideUnitRateOfCementR0] = useState(false);
  const [reload, setReload] = useState(false);
  const [siteName, setSiteName] = useState([]);
  const [cityName, setCityName] = useState([]);
  const [materialName, setMaterialName] = useState([]);
  const [enableInputs, setEnableInputs] = useState(false);
  const { id } = useParams();
  const { Search } = Input;
  const [totalCount, settotalCount] = useState(0);
  const [rfqHistory, setRFQHistory] = useState([]);
  const [categoryTree, setCategoryTree] = useState([]);
  const [dataSource, setDataSource] = useState([]);

  const [summaryDataSource, setSummaryDataSource] = useState([]);
  const [contengency, setContengency] = useState(null);
  const [vendors, setVendors] = useState([]);
  const [siteDetails, setSiteDetails] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const formRef = useRef();
  const [apiLoading, setapiLoading] = useState(false);
  const tableRef = useRef();
  const hiddenTableRef = useRef();
  const [showGST, setShowGST] = useState(false);
  const [loading, setLoading] = useState(false);
  const [state, setState] = useState({
    city_names: [],
    site_names: [],
    material_type_names: [],
  });
  const [buyerName, setBuyerName] = useState(null);
  const [hideInitialBidPrice, sethideInitialBidPrice] = useState(false);
  const [hideR1BidPrice, setHideR1BidPrice] = useState(false);
  const [hideRBidPrice, setHideRBidPrice] = useState(false);
  const [showUnitRateCementR1, setShowUnitRateCementR1] = useState(false);
  const [showUnitRateCementR, setShowUnitRateCementR] = useState(false);
  const [isFinalBidPrice, setIsFinalBidPrice] = useState(false);
  const [showAdditionalCheckboxesFinal, setShowAdditionalCheckboxesFinal] =
    useState(true);
  const [showAdditionalCheckboxes, setShowAdditionalCheckboxes] =
    useState(false);
  const [comparativesRFQ, setComparativesRFQ] = useState([]);
  const [summaryTableData, setSummaryTableData] = useState([]);
  const [hideR0, setHideR0] = useState(false);
  const [hideR1, setHideR1] = useState(false);
  const [rfqNumber, setRfqNumber] = useState(null);
  const [showR1, setShowR1] = useState(false);
  const [showR0, setShowR0] = useState(false);
  const [showR, setShowR] = useState(false);
  const [showLPP, setShowLPP] = useState(false);
  const [vendorBidDates, setVendorBidDates] = useState({});
  const [summaryColumn, setSummaryColumn] = useState([]);

  const getCustomText = (text, record) => {
    if (record.city === "Basic Price") {
      return `${text}`;
    } else if (record.city === "Taxes") {
      return (
        <Tooltip
          color={"#094E8F"}
          placement="top"
          title={
            <span style={{ color: "#fff" }}>Sum of basic amount * GST</span>
          }
        >
          {`${text}`}
        </Tooltip>
      );
    } else if (record.city === "Commission Charges") {
      return (
        <Tooltip
          color={"#094E8F"}
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Sum of basic amount * commission charge from business setting
            </span>
          }
        >
          {`${text}`}
        </Tooltip>
      );
    } else if (record.city === "Contingency") {
      return (
        <Tooltip
          color={"#094E8F"}
          placement="top"
          title={
            <span style={{ color: "#fff" }}>
              Sum of basic amount * Contingency charge from business setting
            </span>
          }
        >
          {text} @ {contengency}% on [
          <Tooltip
            color={"#094E8F"}
            placement="right"
            title={<span style={{ color: "#fff" }}>Total Evaluated Price</span>}
          >
            <span style={{ backgroundColor: "#FFD3B3", padding: "5px" }}>
              D1
            </span>
          </Tooltip>
          ]
        </Tooltip>
      );
    } else if (record.city === "Total Without Tax") {
      return (
        <>
          {text} [
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Basic Price</span>}
          >
            <span style={{ backgroundColor: "#A3F2EB", padding: "5px" }}>
              A1
            </span>
          </Tooltip>
          ]
        </>
      );
    } else if (record.city === "Commercial Ranking on Total Price") {
      return (
        <>
          Commercial Ranking On Total Price{" "}
          <span
            style={{
              backgroundColor: "#FFD3B3",
              borderRadius: "4px",
              padding: "2px 6px",
              marginLeft: "4px",
              fontWeight: "bold",
              display: "inline-block",
            }}
          >
            D1
          </span>
        </>
      );
    } else if (record.city === "Total Price") {
      return (
        <>
          {"Total Evaluated Price"} [
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Basic Price</span>}
          >
            <span style={{ backgroundColor: "#A3F2EB", padding: "5px" }}>
              A1
            </span>
          </Tooltip>{" "}
          +{" "}
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Commission Charges</span>}
          >
            <span style={{ backgroundColor: "#CCD5FF", padding: "5px" }}>
              B1
            </span>
          </Tooltip>{" "}
          +{" "}
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Taxes</span>}
          >
            <span style={{ backgroundColor: "#FFEFA8", padding: "5px" }}>
              C1
            </span>
          </Tooltip>
          ]
        </>
      );
    } else if (record.city === "Total With Tax") {
      return (
        <>
          {"Total Proposed Cost"} [
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Total Evaluated Price</span>}
          >
            <span style={{ backgroundColor: "#FFD3B3", padding: "5px" }}>
              D1
            </span>
          </Tooltip>{" "}
          +{" "}
          <Tooltip
            color={"#094E8F"}
            placement="top"
            title={<span style={{ color: "#fff" }}>Contingency</span>}
          >
            <span style={{ backgroundColor: "#FF9E96", padding: "5px" }}>
              E1
            </span>
          </Tooltip>
          ]
        </>
      );
    }
    return text;
  };

  const predefinedColors = {
    A1: "#A3F2EB",
    B1: "#CCD5FF",
    C1: "#FFEFA8",
    D1: "#FFD3B3",
    E1: "#FF9E96",
    F1: "#F4B9F4",
    G1: "#CCE5E5",
    H1: "#E1FF97",
    I1: "#ADFFC7",
    K1: "#FFD3B3", // peach for K1
    L: "rgb(255 157 43)",
    L1: "rgb(225 127 43)",
    M: "rgb(155 157 3)",
    M1: "rgb(255 245 84)",
  };

  const getColor = (text) => {
    if (/^\d/.test(text)) {
      return null;
    }

    if (predefinedColors[text]) {
      return predefinedColors[text];
    }

    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360;
    return `hsl(${hue}, 70%, 80%)`;
  };

  const findLatestAvailableRound = (vendorDetail, vendorSubTotals) => {
    if (!vendorDetail) return null;

    const roundPriority = { r: 3, r1: 2, r0: 1 };

    const hasPricesForRound = (round) => {
      return vendorDetail.diameter_details?.some((detail) => {
        const priceArray = detail[`${round}_price`] || [];
        return (
          priceArray.length > 0 && priceArray[0]?.r_unit_price !== undefined
        );
      });
    };

    const vendorRounds = vendorSubTotals
      .filter((v) => v.vendor_name === vendorDetail.vendor_name)
      .filter((v) => {
        return (
          v.basic_price > 0 || v.total_price > 0 || v.total_without_tax > 0
        );
      })
      .sort((a, b) => roundPriority[b.round] - roundPriority[a.round]);

    if (vendorRounds.length > 0) {
      return vendorRounds[0].round;
    }

    const fallbackRounds = ["r", "r1", "r0"];
    for (const round of fallbackRounds) {
      if (hasPricesForRound(round)) {
        return round;
      }
    }

    return null;
  };

  useEffect(() => {
    const getVendorBidRFQ = async () => {
      setapiLoading(true);
      try {
        const response = await patchRequest(
          `comparative-rfq/${id}/get-comparative-details-by-material-wise/`
        );
        if (response.data.data) {
          const responseData =
            response?.data?.data?.comparative_details_by_rfq_site_wise;
          setBuyerName(response.data.data.buyer_name);
          setRfqNumber(response.data.data.rfq_number);
          setContengency(response.data.data.contingency_charges);
          let dataSource = [];
          let summaryDataSource = [];
          let prevCity = "";
          let prevMaterial = "";
          let prevSite = "";
          const uniqueVendors = new Set();
          let vendorBidDatesTemp = {};
          const materialName = [];
          const cityName = [];

          responseData.forEach((cityDetail, cityIndex) => {
            cityName.push({
              id: cityDetail.rfq_city_name,
              name: cityDetail.rfq_city_name,
            });
            let prevSubCategory = "";
            cityDetail.rfq_material_wise_details.forEach(
              (materialDetail, materialIndex) => {
                materialName.push({
                  id: materialDetail.rfq_material_type_id,
                  name: materialDetail.rfq_material_type_name,
                });
                materialDetail.rfq_site_wise_details.forEach(
                  (siteDetail, siteIndex) => {
                    const currentSubCategory =
                      materialDetail.rfq_material_type_sub_category || "";
                    

                    const diameterSet = new Set();
                    (siteDetail.vendors || []).forEach((vendor) => {
                      (vendor.diameter_details || []).forEach((dia) => {
                        if (
                          dia.diameter_value !== undefined &&
                          dia.diameter_value !== null
                        ) {
                          diameterSet.add(Number(dia.diameter_value));
                        }
                        uniqueVendors.add(vendor.vendor_name);
                      });
                    });
                    const uniqueDiameters = Array.from(diameterSet).sort(
                      (a, b) => a - b
                    );

                    uniqueDiameters.forEach((diameter, diaIndex) => {
                      const isFirstMaterial = diaIndex === 0;
                      const showCity =
                        isFirstMaterial && prevCity !== cityDetail.rfq_city_name
                          ? cityDetail.rfq_city_name
                          : "";
                      const showMaterial =
                        isFirstMaterial &&
                        prevMaterial !== materialDetail.rfq_material_type_name
                          ? materialDetail.rfq_material_type_name
                          : "";
                      const showSite =
                        prevSite !== siteDetail.rfq_site_name
                          ? siteDetail.rfq_site_name
                          : "";
                      if (isFirstMaterial) prevCity = cityDetail.rfq_city_name;
                      prevMaterial = materialDetail.rfq_material_type_name;
                      prevSite = siteDetail.rfq_site_name;
                      const currentSubCategory = materialDetail.rfq_material_type_sub_category || "";
                    const showSubCategory =
                      diaIndex === 0 &&
                      (materialIndex === 0 || currentSubCategory !== prevSubCategory)
                        ? currentSubCategory
                        : "";
                      let rowData = {
                        key: `row-${cityIndex}-${materialIndex}-${siteIndex}-${diaIndex}`,
                        srNo: `${cityIndex + 1}.${materialIndex + 1}`,
                        city: showCity,
                        subCategory: showSubCategory,
                        materialType: showMaterial,
                        site: showSite,
                        diameter: diameter ? `${diameter} MM` : "",
                        qty: "",
                        uom: isFirstMaterial ? siteDetail.rfq_site_uom : "",
                        gst_rate: isFirstMaterial
                          ? materialDetail.gst_rate
                          : "",
                      };

                      const vendorMap = {};
                      (siteDetail.vendors || []).forEach((vendor) => {
                        const key = vendor.vendor_name
                          .toLowerCase()
                          .replace(/\s+/g, "");
                        if (!vendorMap[key]) {
                          vendorMap[key] = {
                            ...vendor,
                            diameter_details: [
                              ...(vendor.diameter_details || []),
                            ],
                          };
                        } else {
                          vendorMap[key].diameter_details = [
                            ...(vendorMap[key].diameter_details || []),
                            ...(vendor.diameter_details || []),
                          ];
                        }
                      });
                      const mergedVendors = Object.values(vendorMap);

                      mergedVendors.forEach((vendor) => {
                        const vendorKey = vendor.vendor_name
                          .toLowerCase()
                          .replace(/\s+/g, "");
                        const diaDetail = (vendor.diameter_details || []).find(
                          (d) => Number(d.diameter_value) === Number(diameter)
                        );
                        const priceR0 = diaDetail?.r0_price?.[0] || {};
                        const priceR1 = diaDetail?.r1_price?.[0] || {};
                        const priceR = diaDetail?.r_price?.[0] || {};

                        rowData[`${vendorKey}UnitPriceR0`] =
                          priceR0.r_unit_price !== undefined
                            ? priceR0.r_unit_price.toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                              })
                            : "N/A";
                        rowData[`${vendorKey}AmountR0`] =
                          priceR0.r_amount_without_gst !== undefined
                            ? priceR0.r_amount_without_gst.toLocaleString(
                                "en-IN",
                                { maximumFractionDigits: 0 }
                              )
                            : "N/A";
                        rowData[`${vendorKey}BidDateR0`] =
                          priceR0.bid_date || "N/A";
                        rowData[`${vendorKey}UnitPriceR1`] =
                          priceR1.r_unit_price !== undefined
                            ? priceR1.r_unit_price.toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                              })
                            : "N/A";
                        rowData[`${vendorKey}AmountR1`] =
                          priceR1.r_amount_without_gst !== undefined
                            ? priceR1.r_amount_without_gst.toLocaleString(
                                "en-IN",
                                { maximumFractionDigits: 0 }
                              )
                            : "N/A";
                        rowData[`${vendorKey}BidDateR1`] =
                          priceR1.bid_date || "N/A";
                        rowData[`${vendorKey}UnitPriceR`] =
                          priceR.r_unit_price !== undefined
                            ? priceR.r_unit_price.toLocaleString("en-IN", {
                                maximumFractionDigits: 0,
                              })
                            : "N/A";
                        rowData[`${vendorKey}AmountR`] =
                          priceR.r_amount_without_gst !== undefined
                            ? priceR.r_amount_without_gst.toLocaleString(
                                "en-IN",
                                { maximumFractionDigits: 0 }
                              )
                            : "N/A";
                        rowData[`${vendorKey}BidDateR`] =
                          priceR.bid_date || "N/A";

                        vendorBidDatesTemp[vendorKey] =
                          vendorBidDatesTemp[vendorKey] || {};
                        if (priceR0.bid_date)
                          vendorBidDatesTemp[vendorKey].initialBidDate =
                            priceR0.bid_date || "N/A";
                        if (priceR1.bid_date)
                          vendorBidDatesTemp[vendorKey].revisedBidDate =
                            priceR1.bid_date || "N/A";
                        if (priceR.bid_date)
                          vendorBidDatesTemp[vendorKey].finalBidDate =
                            priceR.bid_date || "N/A";
                      });

                      let foundQty = null;
                      for (const vendor of siteDetail.vendors || []) {
                        const diaDetail = (vendor.diameter_details || []).find(
                          (d) => Number(d.diameter_value) === Number(diameter)
                        );
                        if (
                          diaDetail &&
                          diaDetail.diameter_quantity !== undefined &&
                          diaDetail.diameter_quantity !== null
                        ) {
                          foundQty = diaDetail.diameter_quantity;
                          break;
                        }
                      }
                      rowData.qty = foundQty !== null ? foundQty : "N/A";

                      const priceDetail =
                        (siteDetail.last_purchase_price || [])[0] || {};
                      let itemWiseL1 = "N/A";
                      if (Array.isArray(priceDetail.item_wise_l1)) {
                        const l1Entry = priceDetail.item_wise_l1.find(
                          (l1) => Number(l1.diameter_value) === Number(diameter)
                        );
                    

                        if (
                          l1Entry &&
                          l1Entry.lowest_price !== undefined &&
                          l1Entry.lowest_price !== null
                        ) {
                          itemWiseL1 = l1Entry.lowest_price.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          );
                        }
                      }
                      rowData = {
                        ...rowData,
                        poDate: priceDetail.lpp_po_number_date || "N/A",
                        vendorName: priceDetail.vendor_name || "N/A",
                        unitPrice:
                          priceDetail.unit_price?.toLocaleString("en-IN", {
                            maximumFractionDigits: 0,
                          }) || "N/A",
                        avgPrice:
                          priceDetail["30_days_avg_price"]?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          ) || "N/A",
                        itemWiseL1,
                        cityWise:
                          priceDetail["30_days_avg_price_sb"]?.toLocaleString(
                            "en-IN",
                            { maximumFractionDigits: 0 }
                          ) || "N/A",
                      };

                      // if (!rowData.isSummary && rowData.diameter) {
                      //   const vendorKeys = Object.keys(rowData)
                      //     .filter((key) => key.endsWith("UnitPriceR0") || key.endsWith("UnitPriceR1") || key.endsWith("UnitPriceR"))
                      //     .map((key) => key.replace(/UnitPriceR0|UnitPriceR1|UnitPriceR/, ""));

                      //   vendorKeys.forEach((vendorKey) => {
                      //     const priceKeys = [
                      //       `${vendorKey}UnitPriceR`,
                      //       `${vendorKey}UnitPriceR1`,
                      //       `${vendorKey}UnitPriceR0`,
                      //     ];
                      //     const prices = priceKeys.map((key) => {
                      //       let val = rowData[key];
                      //       if (typeof val === "object" && val?.props?.children) {
                      //         val = val.props.children;
                      //       }
                      //       const numericVal = parseFloat((val || "0").toString().replace(/,/g, ""));
                      //       return isNaN(numericVal) || numericVal <= 0 ? null : numericVal;
                      //     }).filter((val) => val !== null);

                      //     if (prices.length > 0) {
                      //       const minPrice = Math.min(...prices);
                      //       priceKeys.forEach((key) => {
                      //         let val = rowData[key];
                      //         if (typeof val === "object" && val?.props?.children) {
                      //           val = val.props.children;
                      //         }
                      //         const numericVal = parseFloat((val || "0").toString().replace(/,/g, ""));
                      //         if (!isNaN(numericVal) && numericVal === minPrice) {
                      //           rowData[key] = (
                      //             <span style={{ fontWeight: "bolder", color: "green" }}>
                      //               {rowData[key]?.props?.children || rowData[key]}
                      //             </span>
                      //           );
                      //         }
                      //       });
                      //     }
                      //   });
                      // }

                      //                 if (!rowData.isSummary && rowData.diameter) {
                      //   // Get all vendor keys for this row
                      //   const vendorKeys = Object.keys(rowData)
                      //     .filter(
                      //       (key) =>
                      //         key.endsWith("UnitPriceR0") ||
                      //         key.endsWith("UnitPriceR1") ||
                      //         key.endsWith("UnitPriceR")
                      //     )
                      //     .map((key) => key.replace(/UnitPriceR0|UnitPriceR1|UnitPriceR/, ""));

                      //   // Collect all unit prices for all vendors and all rounds
                      //   const allPrices = [];
                      //   vendorKeys.forEach((vendorKey) => {
                      //     const priceKeys = [
                      //       `${vendorKey}UnitPriceR`,
                      //       `${vendorKey}UnitPriceR1`,
                      //       `${vendorKey}UnitPriceR0`,
                      //     ];
                      //     priceKeys.forEach((key) => {
                      //       let val = rowData[key];
                      //       if (typeof val === "object" && val?.props?.children) {
                      //         val = val.props.children;
                      //       }
                      //       const numericVal = parseFloat((val || "0").toString().replace(/,/g, ""));
                      //       if (!isNaN(numericVal) && numericVal > 0) {
                      //         allPrices.push({ key, value: numericVal });
                      //       }
                      //     });
                      //   });

                      //   // Find the minimum price among all
                      //   let minPrice = null;
                      //   allPrices.forEach((obj) => {
                      //     if (minPrice === null || obj.value < minPrice) {
                      //       minPrice = obj.value;
                      //     }
                      //   });

                      //   // Highlight only the cell(s) with the minimum price
                      //   allPrices.forEach((obj) => {
                      //     if (minPrice !== null && obj.value === minPrice && rowData[obj.key]) {
                      //       rowData[obj.key] = (
                      //         <span style={{ fontWeight: "bolder", color: "green" }}>
                      //           {rowData[obj.key]?.props?.children || rowData[obj.key]}
                      //         </span>
                      //       );
                      //     }
                      //   });
                      // }

                      if (!rowData.isSummary && rowData.diameter) {
                        // Get all vendor keys for this row
                        const vendorKeys = Object.keys(rowData)
                          .filter(
                            (key) =>
                              key.endsWith("UnitPriceR0") ||
                              key.endsWith("UnitPriceR1") ||
                              key.endsWith("UnitPriceR")
                          )
                          .map((key) =>
                            key.replace(
                              /UnitPriceR0|UnitPriceR1|UnitPriceR/,
                              ""
                            )
                          );

                        // For each vendor, get their latest available price (R > R1 > R0)
                        const latestPrices = [];
                        vendorKeys.forEach((vendorKey) => {
                          const priceKeys = [
                            `${vendorKey}UnitPriceR`, // R (Final)
                            `${vendorKey}UnitPriceR1`, // R1 (Revised)
                            `${vendorKey}UnitPriceR0`, // R0 (Initial)
                          ];
                          let latestVal = null;
                          let latestKey = null;
                          for (const key of priceKeys) {
                            let val = rowData[key];
                            if (
                              typeof val === "object" &&
                              val?.props?.children
                            ) {
                              val = val.props.children;
                            }
                            const numericVal = parseFloat(
                              (val || "0").toString().replace(/,/g, "")
                            );
                            if (!isNaN(numericVal) && numericVal > 0) {
                              latestVal = numericVal;
                              latestKey = key;
                              break; // Use the first available (R > R1 > R0)
                            }
                          }
                          if (latestVal !== null && latestKey) {
                            latestPrices.push({
                              vendorKey,
                              price: latestVal,
                              key: latestKey,
                            });
                          }
                        });
                        // Find the minimum among the latest prices
                        let minPrice = null;
                        latestPrices.forEach((obj) => {
                          if (minPrice === null || obj.price < minPrice) {
                            minPrice = obj.price;
                          }
                        });
                        // Highlight all vendors with the minimum latest price
                        latestPrices.forEach((obj) => {
                          if (
                            minPrice !== null &&
                            obj.price === minPrice &&
                            rowData[obj.key]
                          ) {
                            rowData[obj.key] = (
                              <span
                                style={{ fontWeight: "bolder", color: "green" }}
                              >
                                {rowData[obj.key]?.props?.children ||
                                  rowData[obj.key]}
                              </span>
                            );
                          }
                        });
                      }

                      dataSource.push(rowData);
                    });

                    if (
                      siteDetail.vendor_sub_total &&
                      siteDetail.vendor_sub_total.length !== 0
                    ) {
                      const vendorSubTotals = siteDetail.vendor_sub_total || [];
                      const entries = [
                        {
                          srNo: "A1",
                          keySuffix: "basic_price",
                          city: "Basic Price",
                        },
                        {
                          srNo: "B1",
                          keySuffix: "commission_charges",
                          city: "Commission Charges",
                        },
                        { srNo: "C1", keySuffix: "taxes", city: "Taxes" },
                        {
                          srNo: "D1",
                          keySuffix: "total_price",
                          city: "Total Price",
                        },
                        {
                          srNo: "E1",
                          keySuffix: "contingency",
                          city: "Contingency",
                        },
                        {
                          srNo: "F1",
                          keySuffix: "total_with_tax",
                          city: "Total With Tax",
                        },
                        {
                          srNo: "H1",
                          keySuffix: "payment_terms",
                          city: "Payment Terms",
                        },
                        {
                          srNo: "I1",
                          keySuffix: "payment_security_details",
                          city: "Payment Security Details",
                        },
                        {
                          srNo: "K1",
                          keySuffix: "commercial_ranking",
                          city: "Commercial Ranking on Total Price",
                        },
                      ];

                      entries.forEach((entry) => {
                        const rowData = {
                          key:
                            entry.keySuffix === "commercial_ranking"
                              ? "commercial_ranking-17"
                              : `${entry.keySuffix}-${cityIndex}-${materialIndex}-${siteIndex}`,
                          city: entry.city,
                          srNo: entry.srNo,
                          site: "",
                          materialType: "",
                          uom: "",
                        };

                        if (entry.keySuffix === "commercial_ranking") {

                          const roundDetails = vendorSubTotals
                            .map((vendorDetail) => {

                              const latestRound = findLatestAvailableRound(
                                vendorDetail,
                                vendorSubTotals
                              );

                              return vendorSubTotals.find(
                                (v) =>
                                  v.vendor_name === vendorDetail.vendor_name &&
                                  v.round === latestRound
                              );
                            })
                            .filter(Boolean);

                          const commercialRankingValues = roundDetails
                            .map((vendor) => vendor.commercial_ranking)
                            .filter((value) => typeof value === "number");
                          const sortedRankingValues = [
                            ...new Set(commercialRankingValues),
                          ].sort((a, b) => a - b);
                          const lowest = sortedRankingValues[0] || null;
                          const secondLowest = sortedRankingValues[1] || null;
                          const thirdLowest = sortedRankingValues[2] || null;
                          ["r0", "r1", "r"].forEach((round) => {
                            const roundDetails = vendorSubTotals.filter(
                              (vendorDetail) => vendorDetail.round === round
                            );
                            roundDetails.forEach((vendorDetail) => {
                              const vendorKey = vendorDetail.vendor_name
                                .toLowerCase()
                                .replace(/\s+/g, "");
                              let cellContent = null;
                              // Only show for latest round, blank for others
                              const latestRound = findLatestAvailableRound(
                                vendorDetail,
                                vendorSubTotals
                              );
                              if (vendorDetail.round === latestRound) {
                                if (
                                  vendorDetail.commercial_ranking === lowest
                                ) {
                                  cellContent = (
                                    <Tooltip
                                      color={"#094E8F"}
                                      placement="top"
                                      title={
                                        <span style={{ color: "#fff" }}>
                                          Lowest Price
                                        </span>
                                      }
                                    >
                                      <span className="lowest">L1</span>
                                    </Tooltip>
                                  );
                                } else if (
                                  vendorDetail.commercial_ranking ===
                                  secondLowest
                                ) {
                                  cellContent = (
                                    <Tooltip
                                      color={"#094E8F"}
                                      placement="top"
                                      title={
                                        <span style={{ color: "#fff" }}>
                                          Second Lowest Price
                                        </span>
                                      }
                                    >
                                      <span className="secondLowest">L2</span>
                                    </Tooltip>
                                  );
                                } else if (
                                  vendorDetail.commercial_ranking ===
                                  thirdLowest
                                ) {
                                  cellContent = (
                                    <Tooltip
                                      color={"#094E8F"}
                                      placement="top"
                                      title={
                                        <span style={{ color: "#fff" }}>
                                          Third Lowest Price
                                        </span>
                                      }
                                    >
                                      <span className="thirdLowest">L3</span>
                                    </Tooltip>
                                  );
                                } else {
                                  cellContent = null;
                                }
                              } else {
                                cellContent = null; // Blank for non-latest rounds
                              }
                              rowData[
                                `${vendorKey}Amount${round.toUpperCase()}`
                              ] = cellContent;
                              rowData[`${vendorKey}Amount`] = cellContent;
                            });
                          });
                        } else if (entry.keySuffix !== "commercial_ranking") {
                          (siteDetail.vendors || []).forEach((vendor) => {
                            const vendorKey = vendor.vendor_name
                              .toLowerCase()
                              .replace(/\s+/g, "");
                            const vendorSubR = vendorSubTotals.find(
                              (v) =>
                                v.vendor_name === vendor.vendor_name &&
                                v.round === "r"
                            );
                            const vendorSubR1 = vendorSubTotals.find(
                              (v) =>
                                v.vendor_name === vendor.vendor_name &&
                                v.round === "r1"
                            );
                            const vendorSubR0 = vendorSubTotals.find(
                              (v) =>
                                v.vendor_name === vendor.vendor_name &&
                                v.round === "r0"
                            );

                            rowData[`${vendorKey}AmountR`] =
                              vendorSubR &&
                              vendorSubR[entry.keySuffix] !== undefined
                                ? typeof vendorSubR[entry.keySuffix] ===
                                  "number"
                                  ? vendorSubR[entry.keySuffix].toLocaleString(
                                      "en-IN",
                                      { maximumFractionDigits: 0 }
                                    )
                                  : vendorSubR[entry.keySuffix]
                                : "N/A";
                            rowData[`${vendorKey}AmountR_raw`] =
                              vendorSubR &&
                              typeof vendorSubR[entry.keySuffix] === "number"
                                ? vendorSubR[entry.keySuffix]
                                : null;
                            rowData[`${vendorKey}AmountR1`] =
                              vendorSubR1 &&
                              vendorSubR1[entry.keySuffix] !== undefined
                                ? typeof vendorSubR1[entry.keySuffix] ===
                                  "number"
                                  ? vendorSubR1[entry.keySuffix].toLocaleString(
                                      "en-IN",
                                      { maximumFractionDigits: 0 }
                                    )
                                  : vendorSubR1[entry.keySuffix]
                                : "N/A";
                            rowData[`${vendorKey}AmountR1_raw`] =
                              vendorSubR1 &&
                              typeof vendorSubR1[entry.keySuffix] === "number"
                                ? vendorSubR1[entry.keySuffix]
                                : null;
                            rowData[`${vendorKey}AmountR0`] =
                              vendorSubR0 &&
                              vendorSubR0[entry.keySuffix] !== undefined
                                ? typeof vendorSubR0[entry.keySuffix] ===
                                  "number"
                                  ? vendorSubR0[entry.keySuffix].toLocaleString(
                                      "en-IN",
                                      { maximumFractionDigits: 0 }
                                    )
                                  : vendorSubR0[entry.keySuffix]
                                : "N/A";
                            rowData[`${vendorKey}AmountR0_raw`] =
                              vendorSubR0 &&
                              typeof vendorSubR0[entry.keySuffix] === "number"
                                ? vendorSubR0[entry.keySuffix]
                                : null;

                            const latestRound = findLatestAvailableRound(
                              vendor,
                              vendorSubTotals
                            );

                           
                            let latestVal = "N/A";
                            let latestRaw = null;
                            if (
                              latestRound === "r" &&
                              vendorSubR &&
                              vendorSubR[entry.keySuffix] !== undefined
                            ) {
                              latestVal =
                                typeof vendorSubR[entry.keySuffix] === "number"
                                  ? vendorSubR[entry.keySuffix].toLocaleString(
                                      "en-IN",
                                      { maximumFractionDigits: 0 }
                                    )
                                  : vendorSubR[entry.keySuffix];
                              latestRaw =
                                typeof vendorSubR[entry.keySuffix] === "number"
                                  ? vendorSubR[entry.keySuffix]
                                  : null;
                            } else if (
                              latestRound === "r1" &&
                              vendorSubR1 &&
                              vendorSubR1[entry.keySuffix] !== undefined
                            ) {
                              latestVal =
                                typeof vendorSubR1[entry.keySuffix] === "number"
                                  ? vendorSubR1[entry.keySuffix].toLocaleString(
                                      "en-IN",
                                      { maximumFractionDigits: 0 }
                                    )
                                  : vendorSubR1[entry.keySuffix];
                              latestRaw =
                                typeof vendorSubR1[entry.keySuffix] === "number"
                                  ? vendorSubR1[entry.keySuffix]
                                  : null;
                            } else if (
                              latestRound === "r0" &&
                              vendorSubR0 &&
                              vendorSubR0[entry.keySuffix] !== undefined
                            ) {
                              latestVal =
                                typeof vendorSubR0[entry.keySuffix] === "number"
                                  ? vendorSubR0[entry.keySuffix].toLocaleString(
                                      "en-IN",
                                      { maximumFractionDigits: 0 }
                                    )
                                  : vendorSubR0[entry.keySuffix];
                              latestRaw =
                                typeof vendorSubR0[entry.keySuffix] === "number"
                                  ? vendorSubR0[entry.keySuffix]
                                  : null;
                            }
                            rowData[`${vendorKey}Amount`] = latestVal;
                            rowData[`${vendorKey}Amount_raw`] = latestRaw;
                          });
                        }

                        dataSource.push(rowData);
                      });

                      const materialRows = {};
                      vendorSubTotals.forEach((vendorDetail) => {
                        const materialTypeDetails =
                          vendorDetail.material_type_details || {};
                        const vendorName = vendorDetail.vendor_name;
                        const vendorKey = vendorName
                          .toLowerCase()
                          .replace(/\s+/g, "");
                        const round = vendorDetail.round
                          ? vendorDetail.round.toUpperCase()
                          : "";
                        let currentSrNo = "L";
                        Object.entries(materialTypeDetails).forEach(
                          ([materialType, details]) => {
                            if (details) {
                              const avgMT = details.average_unit_price_mt;
                              const avgBag = details.price_per_kg;
                              if (!materialRows[`${materialType}_MT`]) {
                                materialRows[`${materialType}_MT`] = {
                                  srNo: `${currentSrNo}`,
                                  key: `${materialType}_MT_row`,
                                  city: `Average Price/MT - ${materialType}`,
                                };
                              }
                              if (!materialRows[`${materialType}_Bag`]) {
                                materialRows[`${materialType}_Bag`] = {
                                  srNo: `${currentSrNo}1`,
                                  key: `${materialType}_Bag_row`,
                                  city: `Average Price/KG - ${materialType}`,
                                };
                              }
                              currentSrNo = String.fromCharCode(
                                currentSrNo.charCodeAt(0) + 1
                              );
                              materialRows[`${materialType}_MT`][
                                `${vendorKey}Amount${round}`
                              ] = avgMT?.toFixed(2) || "N/A";
                              materialRows[`${materialType}_Bag`][
                                `${vendorKey}Amount${round}`
                              ] = avgBag?.toFixed(2) || "N/A";
                            }
                          }
                        );
                      });
                      Object.values(materialRows).forEach((row) =>
                        dataSource.push(row)
                      );
                    }
                  }
                );
              }
            );
          });

          responseData.forEach((cityDetail) => {
            cityDetail.rfq_material_wise_details.forEach((materialDetail) => {
              const siteWithSummary = materialDetail.rfq_site_wise_details.find(
                (site) => site.vendor_summary && site.vendor_summary.length > 0
              );

              if (!siteWithSummary) {
                console.warn(
                  `No vendor_summary found for ${materialDetail.rfq_material_type_name} in ${cityDetail.rfq_city_name}`
                );
                return;
              }

              let uniqueSummaryKeyCounter = 1;
              const summaryEntries = [
                {
                  keySuffix: "supply_site_wise",
                  siteName: "Supply - Site Wise",
                },
                {
                  keySuffix: "freight_site_wise",
                  siteName: "Freight - Site Wise",
                },
                { keySuffix: "sub_total", siteName: "Sub Total (Site Wise)" },
                {
                  keySuffix: "supply_site_order_value",
                  siteName: "Supply as a % of respective site order value",
                },
                {
                  keySuffix: "freight_site_order_value",
                  siteName: "Freight as a % of respective site order value",
                },
              ];

              summaryEntries.forEach((entry) => {
                const rowData = {
                  srNo: `${uniqueSummaryKeyCounter++}`,
                  city: cityDetail.rfq_city_name,
                  material: materialDetail.rfq_material_type_name,
                  site: siteWithSummary.rfq_site_name,
                  title: entry.siteName,
                  uom:
                    siteWithSummary.vendor_summary[0]?.uom ||
                    materialDetail.rfq_material_type_uom ||
                    "MT",
                };

                siteWithSummary.vendor_summary.forEach((vendorDetail) => {
                  const vendorKey = vendorDetail.vendor_name
                    .toLowerCase()
                    .replace(/\s+/g, "");
                  rowData[`${vendorKey}Amount`] =
                    entry.keySuffix === "supply_site_order_value" ||
                    entry.keySuffix === "freight_site_order_value"
                      ? `${vendorDetail[entry.keySuffix]?.toFixed(2)}`
                      : `${vendorDetail[entry.keySuffix]?.toLocaleString(
                          "en-IN",
                          {
                            maximumFractionDigits: 0,
                          }
                        )}`;
                });

                summaryDataSource.push(rowData);
              });
            });
          });

          const summaryTitlesToRemove = [
            "Supply - Site Wise",
            "Freight - Site Wise",
            "Sub Total (Site Wise)",
            "Supply as a % of respective site order value",
            "Freight as a % of respective site order value",
          ];

          dataSource = dataSource.filter(
            (row) =>
              !summaryTitlesToRemove.includes(row.city) &&
              !summaryTitlesToRemove.includes(row.title)
          );

          const materialTypes =
            response.data.data.comparative_details_by_rfq_site_wise.flatMap(
              (cityItem) =>
                cityItem.rfq_material_wise_details.map((materialItem) => ({
                  id: materialItem.rfq_material_type_id,
                  name: materialItem.rfq_material_type_name,
                }))
            );
          const uniqueMaterialTypes = materialTypes.filter(
            (material, index, self) =>
              index ===
              self.findIndex(
                (m) => m.id === material.id && m.name === material.name
              )
          );
          setMaterialName(uniqueMaterialTypes);
          setCityName(cityName);
          setVendorBidDates(vendorBidDatesTemp);
          setDataSource(dataSource);
          setSummaryDataSource(summaryDataSource);

          const vendorArr = Array.from(uniqueVendors);
          setVendors(vendorArr);
          const vendorSummaryColumns = (
            Array.isArray(vendorArr) ? vendorArr : []
          ).map((vendorName) => {
            const vendorKey = vendorName.toLowerCase().replace(/\s+/g, "");
            const bidDates = vendorBidDatesTemp[vendorKey] || {};
            const hasFinalBid =
              bidDates.finalBidDate && bidDates.finalBidDate !== "N/A";
            const hasRevisedBid =
              bidDates.revisedBidDate && bidDates.revisedBidDate !== "N/A";
            const hasInitialBid =
              bidDates.initialBidDate && bidDates.initialBidDate !== "N/A";
            let round = "";
            if (hasFinalBid) {
              round = "R - Final";
            } else if (hasRevisedBid) {
              round = "R1 - Revised";
            } else if (hasInitialBid) {
              round = "R0 - Initial";
            }
            return {
              title: vendorName,
              children: [
                {
                  title: round || "N/A",
                  align: "center",
                  children: [
                    {
                      title: "Basic Amount",
                      dataIndex: `${vendorKey}Amount`,
                      key: `${vendorKey}Amount`,
                      align: "right",
                      render: (value) => value || "N/A",
                    },
                  ],
                },
              ],
            };
          });
          setSummaryColumn(vendorSummaryColumns);
          setVendors(vendorArr.map((vendorName) => ({ vendorName })));
        } else {
          ErrorNotificationMsg(t("Error in Comparatives"));
        }
        setapiLoading(false);
      } catch (error) {
        setapiLoading(false);
        console.error("Error:", error);
      }
    };
    getVendorBidRFQ();
  }, [id]);

  const uniqueVendors = new Set();
  const uniqueVendors2 = new Set();

  const exportToExcel = async () => {
    const canvas = await html2canvas(tableRef.current, { scale: 2 });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const headline = "Comparatives - City Wise";
    pdf.setFontSize(18);
    const textWidth = pdf.getTextWidth(headline);
    const centerX = (pageWidth - textWidth) / 2;
    const centerY = pageHeight / 2 - 20;

    pdf.text(headline, centerX, 20);
    const imgWidth = 190;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 10, 30, imgWidth, imgHeight);
    pdf.save(`Comparatives-${rfqNumber}`);
  };

  const handleCheckboxChange = () => {
    setIsFinalBidPrice(!isFinalBidPrice);
    setShowAdditionalCheckboxesFinal(true);

    setState((prevState) => ({
      ...prevState,
      is_final_bid_price: !isFinalBidPrice,
    }));
  };

  const handleCheckboxhideR0 = () => {
    setShowR0(!showR0);
  };

  const handleCheckboxhideLPP = () => {
    setShowLPP(!showLPP);
  };

  const handleCheckboxhideGST = () => {
    setShowGST(!showGST);
  };

  const handleCheckboxhideR1 = () => {
    setShowR1(!showR1);
  };

  const handleCheckboxhideRR = () => {
    setHideRBidPrice(!hideRBidPrice);
  };

  const handleHideR0Change = (e) => {
    setHideR0(e.target.checked);
  };
  const handleHideR1Change = (e) => {
    setHideR1(e.target.checked);
  };

  const updateState = async () => {
    try {
      setapiLoading(true); // Start loading
      const payload = {
        city_names: state.city_names.length !== 0 ? state.city_names : null,
        site_names: state.site_names.length !== 0 ? state.site_names : null,
        material_type_names:
          state.material_type_names.length !== 0
            ? state.material_type_names
            : null,
      };
      const response = await patchRequest(
        `comparative-rfq/${id}/get-comparative-details-by-material-wise/`,
        payload
      );

      if (response.data.data) {
        const responseData =
          response?.data?.data?.comparative_details_by_rfq_site_wise;
        setBuyerName(response.data.data.buyer_name);
        setRfqNumber(response.data.data.rfq_number);
        setContengency(response.data.data.contingency_charges);

        let dataSource = [];
        let summaryDataSource = [];
        let prevCity = "";
        let prevMaterial = "";
        let prevSite = "";
        const uniqueVendors = new Set();
        let vendorBidDatesTemp = {};
        const materialName = [];
        const cityName = [];

        responseData.forEach((cityDetail, cityIndex) => {
          if (
            state.city_names.length === 0 ||
            state.city_names.includes(cityDetail.rfq_city_name)
          ) {
            cityName.push({
              id: cityDetail.rfq_city_name,
              name: cityDetail.rfq_city_name,
            });
            let prevSubCategory = "";
            cityDetail.rfq_material_wise_details.forEach(
              (materialDetail, materialIndex) => {
                if (
                  state.material_type_names.length === 0 ||
                  state.material_type_names.includes(
                    materialDetail.rfq_material_type_name
                  )
                ) {
                  materialName.push({
                    id: materialDetail.rfq_material_type_id,
                    name: materialDetail.rfq_material_type_name,
                  });

                  materialDetail.rfq_site_wise_details.forEach(
                    (siteDetail, siteIndex) => {
                      const diameterSet = new Set();
                      (siteDetail.vendors || []).forEach((vendor) => {
                        (vendor.diameter_details || []).forEach((dia) => {
                          if (
                            dia.diameter_value !== undefined &&
                            dia.diameter_value !== null
                          ) {
                            diameterSet.add(Number(dia.diameter_value));
                          }
                          uniqueVendors.add(vendor.vendor_name);
                        });
                      });
                      const uniqueDiameters = Array.from(diameterSet).sort(
                        (a, b) => a - b
                      );

                      uniqueDiameters.forEach((diameter, diaIndex) => {
                        const isFirstMaterial = diaIndex === 0;
                        const showCity =
                          isFirstMaterial &&
                          prevCity !== cityDetail.rfq_city_name
                            ? cityDetail.rfq_city_name
                            : "";
                        const showMaterial =
                          isFirstMaterial &&
                          prevMaterial !== materialDetail.rfq_material_type_name
                            ? materialDetail.rfq_material_type_name
                            : "";
                        const showSite =
                          prevSite !== siteDetail.rfq_site_name
                            ? siteDetail.rfq_site_name
                            : "";
                        if (isFirstMaterial)
                          prevCity = cityDetail.rfq_city_name;
                        prevMaterial = materialDetail.rfq_material_type_name;
                        prevSite = siteDetail.rfq_site_name;
                        const currentSubCategory = materialDetail.rfq_material_type_sub_category || "";
                    const showSubCategory =
                      diaIndex === 0 &&
                      (materialIndex === 0 || currentSubCategory !== prevSubCategory)
                        ? currentSubCategory
                        : "";
                        let rowData = {
                          key: `row-${cityIndex}-${materialIndex}-${siteIndex}-${diaIndex}`,
                          srNo: `${cityIndex + 1}.${materialIndex + 1}`,
                          city: showCity,
                          subCategory: showSubCategory,
                          materialType: showMaterial,
                          site: showSite,
                          diameter: diameter ? `${diameter} MM` : "",
                          qty: "",
                          uom: isFirstMaterial ? siteDetail.rfq_site_uom : "",
                          gst_rate: isFirstMaterial
                            ? materialDetail.gst_rate
                            : "",
                        };

                        const vendorMap = {};
                        (siteDetail.vendors || []).forEach((vendor) => {
                          const key = vendor.vendor_name
                            .toLowerCase()
                            .replace(/\s+/g, "");
                          if (!vendorMap[key]) {
                            vendorMap[key] = {
                              ...vendor,
                              diameter_details: [
                                ...(vendor.diameter_details || []),
                              ],
                            };
                          } else {
                            vendorMap[key].diameter_details = [
                              ...(vendorMap[key].diameter_details || []),
                              ...(vendor.diameter_details || []),
                            ];
                          }
                        });
                        const mergedVendors = Object.values(vendorMap);

                        mergedVendors.forEach((vendor) => {
                          const vendorKey = vendor.vendor_name
                            .toLowerCase()
                            .replace(/\s+/g, "");
                          const diaDetail = (
                            vendor.diameter_details || []
                          ).find(
                            (d) => Number(d.diameter_value) === Number(diameter)
                          );
                          const priceR0 = diaDetail?.r0_price?.[0] || {};
                          const priceR1 = diaDetail?.r1_price?.[0] || {};
                          const priceR = diaDetail?.r_price?.[0] || {};

                          rowData[`${vendorKey}UnitPriceR0`] =
                            priceR0.r_unit_price !== undefined
                              ? priceR0.r_unit_price.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })
                              : "N/A";
                          rowData[`${vendorKey}AmountR0`] =
                            priceR0.r_amount_without_gst !== undefined
                              ? priceR0.r_amount_without_gst.toLocaleString(
                                  "en-IN",
                                  {
                                    maximumFractionDigits: 0,
                                  }
                                )
                              : "N/A";
                          rowData[`${vendorKey}BidDateR0`] =
                            priceR0.bid_date || "N/A";
                          rowData[`${vendorKey}UnitPriceR1`] =
                            priceR1.r_unit_price !== undefined
                              ? priceR1.r_unit_price.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })
                              : "N/A";
                          rowData[`${vendorKey}AmountR1`] =
                            priceR1.r_amount_without_gst !== undefined
                              ? priceR1.r_amount_without_gst.toLocaleString(
                                  "en-IN",
                                  {
                                    maximumFractionDigits: 0,
                                  }
                                )
                              : "N/A";
                          rowData[`${vendorKey}BidDateR1`] =
                            priceR1.bid_date || "N/A";
                          rowData[`${vendorKey}UnitPriceR`] =
                            priceR.r_unit_price !== undefined
                              ? priceR.r_unit_price.toLocaleString("en-IN", {
                                  maximumFractionDigits: 0,
                                })
                              : "N/A";
                          rowData[`${vendorKey}AmountR`] =
                            priceR.r_amount_without_gst !== undefined
                              ? priceR.r_amount_without_gst.toLocaleString(
                                  "en-IN",
                                  {
                                    maximumFractionDigits: 0,
                                  }
                                )
                              : "N/A";
                          rowData[`${vendorKey}BidDateR`] =
                            priceR.bid_date || "N/A";

                          vendorBidDatesTemp[vendorKey] =
                            vendorBidDatesTemp[vendorKey] || {};
                          if (priceR0.bid_date)
                            vendorBidDatesTemp[vendorKey].initialBidDate =
                              priceR0.bid_date || "N/A";
                          if (priceR1.bid_date)
                            vendorBidDatesTemp[vendorKey].revisedBidDate =
                              priceR1.bid_date || "N/A";
                          if (priceR.bid_date)
                            vendorBidDatesTemp[vendorKey].finalBidDate =
                              priceR.bid_date || "N/A";
                        });

                        let foundQty = null;
                        for (const vendor of siteDetail.vendors || []) {
                          const diaDetail = (
                            vendor.diameter_details || []
                          ).find(
                            (d) => Number(d.diameter_value) === Number(diameter)
                          );
                          if (
                            diaDetail &&
                            diaDetail.diameter_quantity !== undefined &&
                            diaDetail.diameter_quantity !== null
                          ) {
                            foundQty = diaDetail.diameter_quantity;
                            break;
                          }
                        }
                        rowData.qty = foundQty !== null ? foundQty : "N/A";

                        const priceDetail =
                          (siteDetail.last_purchase_price || [])[0] || {};
                        let itemWiseL1 = "N/A";
                        if (Array.isArray(priceDetail.item_wise_l1)) {
                          const l1Entry = priceDetail.item_wise_l1.find(
                            (l1) =>
                              Number(l1.diameter_value) === Number(diameter)
                          );
                          if (
                            l1Entry &&
                            l1Entry.lowest_price !== undefined &&
                            l1Entry.lowest_price !== null
                          ) {
                            itemWiseL1 = l1Entry.lowest_price.toLocaleString(
                              "en-IN",
                              {
                                maximumFractionDigits: 0,
                              }
                            );
                          }
                        }
                        rowData = {
                          ...rowData,
                          poDate: priceDetail.lpp_po_number_date || "N/A",
                          vendorName: priceDetail.vendor_name || "N/A",
                          unitPrice:
                            priceDetail.unit_price?.toLocaleString("en-IN", {
                              maximumFractionDigits: 0,
                            }) || "N/A",
                          avgPrice:
                            priceDetail["30_days_avg_price"]?.toLocaleString(
                              "en-IN",
                              {
                                maximumFractionDigits: 0,
                              }
                            ) || "N/A",
                          itemWiseL1,
                          cityWise:
                            priceDetail["30_days_avg_price_sb"]?.toLocaleString(
                              "en-IN",
                              {
                                maximumFractionDigits: 0,
                              }
                            ) || "N/A",
                        };

                        // Highlight minimum prices
                        if (!rowData.isSummary && rowData.diameter) {
                          const vendorKeys = Object.keys(rowData)
                            .filter(
                              (key) =>
                                key.endsWith("UnitPriceR0") ||
                                key.endsWith("UnitPriceR1") ||
                                key.endsWith("UnitPriceR")
                            )
                            .map((key) =>
                              key.replace(
                                /UnitPriceR0|UnitPriceR1|UnitPriceR/,
                                ""
                              )
                            );

                          const latestPrices = [];
                          vendorKeys.forEach((vendorKey) => {
                            const priceKeys = [
                              `${vendorKey}UnitPriceR`,
                              `${vendorKey}UnitPriceR1`,
                              `${vendorKey}UnitPriceR0`,
                            ];
                            let latestVal = null;
                            let latestKey = null;
                            for (const key of priceKeys) {
                              let val = rowData[key];
                              if (
                                typeof val === "object" &&
                                val?.props?.children
                              ) {
                                val = val.props.children;
                              }
                              const numericVal = parseFloat(
                                (val || "0").toString().replace(/,/g, "")
                              );
                              if (!isNaN(numericVal) && numericVal > 0) {
                                latestVal = numericVal;
                                latestKey = key;
                                break;
                              }
                            }
                            if (latestVal !== null && latestKey) {
                              latestPrices.push({
                                vendorKey,
                                price: latestVal,
                                key: latestKey,
                              });
                            }
                          });

                          let minPrice = null;
                          latestPrices.forEach((obj) => {
                            if (minPrice === null || obj.price < minPrice) {
                              minPrice = obj.price;
                            }
                          });

                          latestPrices.forEach((obj) => {
                            if (
                              minPrice !== null &&
                              obj.price === minPrice &&
                              rowData[obj.key]
                            ) {
                              rowData[obj.key] = (
                                <span
                                  style={{
                                    fontWeight: "bolder",
                                    color: "green",
                                  }}
                                >
                                  {rowData[obj.key]?.props?.children ||
                                    rowData[obj.key]}
                                </span>
                              );
                            }
                          });
                        }

                        dataSource.push(rowData);
                      }); // End of uniqueDiameters.forEach

                      // Add summary rows (Basic Price, Taxes, etc.)
                      if (
                        siteDetail.vendor_sub_total &&
                        siteDetail.vendor_sub_total.length !== 0
                      ) {
                        const vendorSubTotals =
                          siteDetail.vendor_sub_total || [];
                        const entries = [
                          {
                            srNo: "A1",
                            keySuffix: "basic_price",
                            city: "Basic Price",
                          },
                          {
                            srNo: "B1",
                            keySuffix: "commission_charges",
                            city: "Commission Charges",
                          },
                          { srNo: "C1", keySuffix: "taxes", city: "Taxes" },
                          {
                            srNo: "D1",
                            keySuffix: "total_price",
                            city: "Total Price",
                          },
                          {
                            srNo: "E1",
                            keySuffix: "contingency",
                            city: "Contingency",
                          },
                          {
                            srNo: "F1",
                            keySuffix: "total_with_tax",
                            city: "Total With Tax",
                          },
                          {
                            srNo: "H1",
                            keySuffix: "payment_terms",
                            city: "Payment Terms",
                          },
                          {
                            srNo: "I1",
                            keySuffix: "payment_security_details",
                            city: "Payment Security Details",
                          },
                          {
                            srNo: "K1",
                            keySuffix: "commercial_ranking",
                            city: "Commercial Ranking on Total Price",
                          },
                        ];

                        entries.forEach((entry) => {
                          const rowData = {
                            key:
                              entry.keySuffix === "commercial_ranking"
                                ? "commercial_ranking-17"
                                : `${entry.keySuffix}-${cityIndex}-${materialIndex}-${siteIndex}`,
                            city: entry.city,
                            srNo: entry.srNo,
                            site: "",
                            materialType: "",
                            uom: "",
                          };

                          if (entry.keySuffix === "commercial_ranking") {
                            const roundDetails = vendorSubTotals
                              .map((vendorDetail) => {
                                const latestRound = findLatestAvailableRound(
                                  vendorDetail,
                                  vendorSubTotals
                                );
                                return vendorSubTotals.find(
                                  (v) =>
                                    v.vendor_name ===
                                      vendorDetail.vendor_name &&
                                    v.round === latestRound
                                );
                              })
                              .filter(Boolean);

                            const commercialRankingValues = roundDetails
                              .map((vendor) => vendor.commercial_ranking)
                              .filter((value) => typeof value === "number");
                            const sortedRankingValues = [
                              ...new Set(commercialRankingValues),
                            ].sort((a, b) => a - b);
                            const lowest = sortedRankingValues[0] || null;
                            const secondLowest = sortedRankingValues[1] || null;
                            const thirdLowest = sortedRankingValues[2] || null;

                            ["r0", "r1", "r"].forEach((round) => {
                              const roundDetails = vendorSubTotals.filter(
                                (vendorDetail) => vendorDetail.round === round
                              );
                              roundDetails.forEach((vendorDetail) => {
                                const vendorKey = vendorDetail.vendor_name
                                  .toLowerCase()
                                  .replace(/\s+/g, "");
                                let cellContent = null;
                                const latestRound = findLatestAvailableRound(
                                  vendorDetail,
                                  vendorSubTotals
                                );
                                if (vendorDetail.round === latestRound) {
                                  if (
                                    vendorDetail.commercial_ranking === lowest
                                  ) {
                                    cellContent = (
                                      <Tooltip
                                        color={"#094E8F"}
                                        placement="top"
                                        title={
                                          <span style={{ color: "#fff" }}>
                                            Lowest Price
                                          </span>
                                        }
                                      >
                                        <span className="lowest">L1</span>
                                      </Tooltip>
                                    );
                                  } else if (
                                    vendorDetail.commercial_ranking ===
                                    secondLowest
                                  ) {
                                    cellContent = (
                                      <Tooltip
                                        color={"#094E8F"}
                                        placement="top"
                                        title={
                                          <span style={{ color: "#fff" }}>
                                            Second Lowest Price
                                          </span>
                                        }
                                      >
                                        <span className="secondLowest">L2</span>
                                      </Tooltip>
                                    );
                                  } else if (
                                    vendorDetail.commercial_ranking ===
                                    thirdLowest
                                  ) {
                                    cellContent = (
                                      <Tooltip
                                        color={"#094E8F"}
                                        placement="top"
                                        title={
                                          <span style={{ color: "#fff" }}>
                                            Third Lowest Price
                                          </span>
                                        }
                                      >
                                        <span className="thirdLowest">L3</span>
                                      </Tooltip>
                                    );
                                  } else {
                                    cellContent = null;
                                  }
                                } else {
                                  cellContent = null;
                                }
                                rowData[
                                  `${vendorKey}Amount${round.toUpperCase()}`
                                ] = cellContent;
                                rowData[`${vendorKey}Amount`] = cellContent;
                              });
                            });
                          } else {
                            (siteDetail.vendors || []).forEach((vendor) => {
                              const vendorKey = vendor.vendor_name
                                .toLowerCase()
                                .replace(/\s+/g, "");
                              const vendorSubR = vendorSubTotals.find(
                                (v) =>
                                  v.vendor_name === vendor.vendor_name &&
                                  v.round === "r"
                              );
                              const vendorSubR1 = vendorSubTotals.find(
                                (v) =>
                                  v.vendor_name === vendor.vendor_name &&
                                  v.round === "r1"
                              );
                              const vendorSubR0 = vendorSubTotals.find(
                                (v) =>
                                  v.vendor_name === vendor.vendor_name &&
                                  v.round === "r0"
                              );

                              rowData[`${vendorKey}AmountR`] =
                                vendorSubR &&
                                vendorSubR[entry.keySuffix] !== undefined
                                  ? typeof vendorSubR[entry.keySuffix] ===
                                    "number"
                                    ? vendorSubR[
                                        entry.keySuffix
                                      ].toLocaleString("en-IN", {
                                        maximumFractionDigits: 0,
                                      })
                                    : vendorSubR[entry.keySuffix]
                                  : "N/A";
                              rowData[`${vendorKey}AmountR_raw`] =
                                vendorSubR &&
                                typeof vendorSubR[entry.keySuffix] === "number"
                                  ? vendorSubR[entry.keySuffix]
                                  : null;
                              rowData[`${vendorKey}AmountR1`] =
                                vendorSubR1 &&
                                vendorSubR1[entry.keySuffix] !== undefined
                                  ? typeof vendorSubR1[entry.keySuffix] ===
                                    "number"
                                    ? vendorSubR1[
                                        entry.keySuffix
                                      ].toLocaleString("en-IN", {
                                        maximumFractionDigits: 0,
                                      })
                                    : vendorSubR1[entry.keySuffix]
                                  : "N/A";
                              rowData[`${vendorKey}AmountR1_raw`] =
                                vendorSubR1 &&
                                typeof vendorSubR1[entry.keySuffix] === "number"
                                  ? vendorSubR1[entry.keySuffix]
                                  : null;
                              rowData[`${vendorKey}AmountR0`] =
                                vendorSubR0 &&
                                vendorSubR0[entry.keySuffix] !== undefined
                                  ? typeof vendorSubR0[entry.keySuffix] ===
                                    "number"
                                    ? vendorSubR0[
                                        entry.keySuffix
                                      ].toLocaleString("en-IN", {
                                        maximumFractionDigits: 0,
                                      })
                                    : vendorSubR0[entry.keySuffix]
                                  : "N/A";
                              rowData[`${vendorKey}AmountR0_raw`] =
                                vendorSubR0 &&
                                typeof vendorSubR0[entry.keySuffix] === "number"
                                  ? vendorSubR0[entry.keySuffix]
                                  : null;

                              const latestRound = findLatestAvailableRound(
                                vendor,
                                vendorSubTotals
                              );

                              let latestVal = "N/A";
                              let latestRaw = null;
                              if (
                                latestRound === "r" &&
                                vendorSubR &&
                                vendorSubR[entry.keySuffix] !== undefined
                              ) {
                                latestVal =
                                  typeof vendorSubR[entry.keySuffix] ===
                                  "number"
                                    ? vendorSubR[
                                        entry.keySuffix
                                      ].toLocaleString("en-IN", {
                                        maximumFractionDigits: 0,
                                      })
                                    : vendorSubR[entry.keySuffix];
                                latestRaw =
                                  typeof vendorSubR[entry.keySuffix] ===
                                  "number"
                                    ? vendorSubR[entry.keySuffix]
                                    : null;
                              } else if (
                                latestRound === "r1" &&
                                vendorSubR1 &&
                                vendorSubR1[entry.keySuffix] !== undefined
                              ) {
                                latestVal =
                                  typeof vendorSubR1[entry.keySuffix] ===
                                  "number"
                                    ? vendorSubR1[
                                        entry.keySuffix
                                      ].toLocaleString("en-IN", {
                                        maximumFractionDigits: 0,
                                      })
                                    : vendorSubR1[entry.keySuffix];
                                latestRaw =
                                  typeof vendorSubR1[entry.keySuffix] ===
                                  "number"
                                    ? vendorSubR1[entry.keySuffix]
                                    : null;
                              } else if (
                                latestRound === "r0" &&
                                vendorSubR0 &&
                                vendorSubR0[entry.keySuffix] !== undefined
                              ) {
                                latestVal =
                                  typeof vendorSubR0[entry.keySuffix] ===
                                  "number"
                                    ? vendorSubR0[
                                        entry.keySuffix
                                      ].toLocaleString("en-IN", {
                                        maximumFractionDigits: 0,
                                      })
                                    : vendorSubR0[entry.keySuffix];
                                latestRaw =
                                  typeof vendorSubR0[entry.keySuffix] ===
                                  "number"
                                    ? vendorSubR0[entry.keySuffix]
                                    : null;
                              }
                              rowData[`${vendorKey}Amount`] = latestVal;
                              rowData[`${vendorKey}Amount_raw`] = latestRaw;
                            });
                          }

                          dataSource.push(rowData);
                        });

                        const materialRows = {};
                        vendorSubTotals.forEach((vendorDetail) => {
                          const materialTypeDetails =
                            vendorDetail.material_type_details || {};
                          const vendorName = vendorDetail.vendor_name;
                          const vendorKey = vendorName
                            .toLowerCase()
                            .replace(/\s+/g, "");
                          const round = vendorDetail.round
                            ? vendorDetail.round.toUpperCase()
                            : "";
                          let currentSrNo = "L";
                          Object.entries(materialTypeDetails).forEach(
                            ([materialType, details]) => {
                              if (details) {
                                const avgMT = details.average_unit_price_mt;
                                const avgBag = details.price_per_kg;
                                if (!materialRows[`${materialType}_MT`]) {
                                  materialRows[`${materialType}_MT`] = {
                                    srNo: `${currentSrNo}`,
                                    key: `${materialType}_MT_row`,
                                    city: `Average Price/MT - ${materialType}`,
                                  };
                                }
                                if (!materialRows[`${materialType}_Bag`]) {
                                  materialRows[`${materialType}_Bag`] = {
                                    srNo: `${currentSrNo}1`,
                                    key: `${materialType}_Bag_row`,
                                    city: `Average Price/KG - ${materialType}`,
                                  };
                                }
                                currentSrNo = String.fromCharCode(
                                  currentSrNo.charCodeAt(0) + 1
                                );
                                materialRows[`${materialType}_MT`][
                                  `${vendorKey}Amount${round}`
                                ] = avgMT?.toFixed(2) || "N/A";
                                materialRows[`${materialType}_Bag`][
                                  `${vendorKey}Amount${round}`
                                ] = avgBag?.toFixed(2) || "N/A";
                              }
                            }
                          );
                        });
                        Object.values(materialRows).forEach((row) =>
                          dataSource.push(row)
                        );
                      }
                    }
                  ); // End of rfq_site_wise_details.forEach
                } // End of material filter check
              }
            ); // End of rfq_material_wise_details.forEach
          } // End of city filter check
        }); // End of responseData.forEach

          responseData.forEach((cityDetail) => {
            cityDetail.rfq_material_wise_details.forEach((materialDetail) => {
              const siteWithSummary = materialDetail.rfq_site_wise_details.find(
                (site) => site.vendor_summary && site.vendor_summary.length > 0
              );

              if (!siteWithSummary) {
                console.warn(
                  `No vendor_summary found for ${materialDetail.rfq_material_type_name} in ${cityDetail.rfq_city_name}`
                );
                return;
              }

              let uniqueSummaryKeyCounter = 1;
              const summaryEntries = [
                {
                  keySuffix: "supply_site_wise",
                  siteName: "Supply - Site Wise",
                },
                {
                  keySuffix: "freight_site_wise",
                  siteName: "Freight - Site Wise",
                },
                { keySuffix: "sub_total", siteName: "Sub Total (Site Wise)" },
                {
                  keySuffix: "supply_site_order_value",
                  siteName: "Supply as a % of respective site order value",
                },
                {
                  keySuffix: "freight_site_order_value",
                  siteName: "Freight as a % of respective site order value",
                },
              ];

              summaryEntries.forEach((entry) => {
                const rowData = {
                  srNo: `${uniqueSummaryKeyCounter++}`,
                  city: cityDetail.rfq_city_name,
                  material: materialDetail.rfq_material_type_name,
                  site: siteWithSummary.rfq_site_name,
                  title: entry.siteName,
                  uom:
                    siteWithSummary.vendor_summary[0]?.uom ||
                    materialDetail.rfq_material_type_uom ||
                    "MT",
                };

                siteWithSummary.vendor_summary.forEach((vendorDetail) => {
                  const vendorKey = vendorDetail.vendor_name
                    .toLowerCase()
                    .replace(/\s+/g, "");
                  rowData[`${vendorKey}Amount`] =
                    entry.keySuffix === "supply_site_order_value" ||
                    entry.keySuffix === "freight_site_order_value"
                      ? `${vendorDetail[entry.keySuffix]?.toFixed(2)}`
                      : `${vendorDetail[entry.keySuffix]?.toLocaleString(
                          "en-IN",
                          {
                            maximumFractionDigits: 0,
                          }
                        )}`;
                });

                summaryDataSource.push(rowData);
              });
            });
          });

          const summaryTitlesToRemove = [
            "Supply - Site Wise",
            "Freight - Site Wise",
            "Sub Total (Site Wise)",
            "Supply as a % of respective site order value",
            "Freight as a % of respective site order value",
          ];

          dataSource = dataSource.filter(
            (row) =>
              !summaryTitlesToRemove.includes(row.city) &&
              !summaryTitlesToRemove.includes(row.title)
          );

        // setMaterialName(materialName);
        // setCityName(cityName);
        setVendorBidDates(vendorBidDatesTemp);
        setDataSource(dataSource);
        setSummaryDataSource(summaryDataSource);

        const vendorArr = Array.from(uniqueVendors);
        setVendors(vendorArr);
        const vendorSummaryColumns = vendorArr.map((vendorName) => {
          const vendorKey = vendorName.toLowerCase().replace(/\s+/g, "");
          const bidDates = vendorBidDatesTemp[vendorKey] || {};
          const hasFinalBid =
            bidDates.finalBidDate && bidDates.finalBidDate !== "N/A";
          const hasRevisedBid =
            bidDates.revisedBidDate && bidDates.revisedBidDate !== "N/A";
          const hasInitialBid =
            bidDates.initialBidDate && bidDates.initialBidDate !== "N/A";
          let round = "";
          if (hasFinalBid) {
            round = "R - Final";
          } else if (hasRevisedBid) {
            round = "R1 - Revised";
          } else if (hasInitialBid) {
            round = "R0 - Initial";
          }
          return {
            title: vendorName,
            children: [
              {
                title: round || "N/A",
                align: "center",
                children: [
                  {
                    title: "Basic Amount",
                    dataIndex: `${vendorKey}Amount`,
                    key: `${vendorKey}Amount`,
                    align: "right",
                    render: (value) => value || "N/A",
                  },
                ],
              },
            ],
          };
        });
        setSummaryColumn(vendorSummaryColumns);
        setVendors(vendorArr.map((vendorName) => ({ vendorName })));
      } else {
        ErrorNotificationMsg(t("Error in Comparatives"));
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      ErrorNotificationMsg(t("Error fetching site details"));
    } finally {
      setapiLoading(false); // End loading
    }
  };

  const handleSiteNameSelectChange = async (value) => {
    const updatedState1 = { ...state, city_names: value };
    setState(updatedState1);
  };
  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
    } else {
      updateState();
    }
  }, [state]);

  const handleMaterialSelectChange = async (value) => {
    const updatedState2 = { ...state, material_type_names: value };
    setState(updatedState2);
  };

  const handleUnitRateOfCementChangeR0 = (
    value,
    recordKey,
    siteIndex,
    gstRate,
    quantity
  ) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r0_price[0].r0_unit_price = value;
    site.vendorBids[0].r0_price[0].r0_total_price =
      ((value * (100 + gstRate)) / 100) * quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleUnitRateOfFreightChangeR0 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r0_price[0].r0_unit_price = value;
    site.vendorBids[0].r0_price[0].r0_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateR0Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r0_price[0].r0_total_price = value;
    site.vendorBids[0].r0_price[0].r0_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };
  const [enableInputsR1, setEnableInputsR1] = useState(false);

  const handleUnitRateOfCementChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const calculateTotalUnitRateOfCementR1 = (record) => {
    const totalUnitRateOfCementR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfCementR1.toFixed(0);
  };

  const handleUnitRateOfFreightChangeR1 = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_unit_price = value;
    site.vendorBids[0].r1_price[0].r1_total_price = value * site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const handleTotalUnitRateOfCementR1Change = (value, recordKey, siteIndex) => {
    const updatedComparativesRFQ = [...comparativesRFQ];
    const record = updatedComparativesRFQ.find(
      (item) => item.key === recordKey
    );
    const site = record.siteLocations[siteIndex];
    site.vendorBids[0].r1_price[0].r1_total_price = value;
    site.vendorBids[0].r1_price[0].r1_unit_price = value / site.quantity;
    setComparativesRFQ(updatedComparativesRFQ);
  };

  const renderDateR0 = (siteLocations, record) => {
    // return (
    //   <>
    //   </>
    // );
  };

  const renderVendorName = (siteLocations, record) => {
    // return (
    //   <>
    //   </>
    // );
  };

  const renderUnitRateOfTotalUnitRateR0 = (siteLocations, record) => {
    // return (
    //   <>
    //     <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
    //     </div>
    //   </>
    // );
  };

  const calculateTotalUnitRateOfCementR0 = (record) => {
    // const totalUnitRateOfCement = record.siteLocations.reduce(
    //   (total, site) =>
    //     total + (parseFloat(site.vendorBids[0].r0_price[0].r0_unit_price) || 0),
    //   0
    // );
    // return totalUnitRateOfCement.toFixed(2);
  };

  const renderUnitRateOfFreightR0 = (siteLocations, record) => {
    // console.log("reco", record);
    // return (
    //   <>
    //   </>
    // );
  };

  const calculateTotalUnitRateOfFreightR0 = (record) => {
    // const totalUnitRateOfFreightR0 = record.siteLocations.reduce(
    //   (total, site) =>
    //     total + (parseFloat(site.vendorBids[0].r0_price[0].r0_unit_price) || 0),
    //   0
    // );
    // return totalUnitRateOfFreightR0.toFixed(2);
  };

  const calculateTotalUnitRateOfFreightR1 = (record) => {
    const totalUnitRateOfFreightR1 = record.siteLocations.reduce(
      (total, site) =>
        total + (parseFloat(site.vendorBids[0].r1_price[0].r1_unit_price) || 0),
      0
    );
    return totalUnitRateOfFreightR1.toFixed(0);
  };

  const calculateTotalUnitRateOfR1 = (record) => {
    const totalUnitRateOfCementR1 =
      parseFloat(calculateTotalUnitRateOfCementR1(record)) || 0;
    const totalUnitRateOfFreightR1 =
      parseFloat(calculateTotalUnitRateOfFreightR1(record)) || 0;

    return (totalUnitRateOfCementR1 + totalUnitRateOfFreightR1).toFixed(0);
  };

  const vendorNames = new Set();

  // 1. Vendor columns with R0, R1, R subcolumns for each vendor
  const venColumn = Array.isArray(vendors)
    ? vendors.flatMap((vendorObj) => {
        const vendorName = vendorObj.vendorName;
        const vendorKey = vendorName.toLowerCase().replace(/\s+/g, "");
        const bidDates = vendorBidDates[vendorKey] || {};

        let latest = null;
        if (bidDates.finalBidDate && bidDates.finalBidDate !== "N/A") {
          latest = "R";
        } else if (
          bidDates.revisedBidDate &&
          bidDates.revisedBidDate !== "N/A"
        ) {
          latest = "R1";
        } else if (
          bidDates.initialBidDate &&
          bidDates.initialBidDate !== "N/A"
        ) {
          latest = "R0";
        }

        const columns = [];

        if (latest === "R") {
          columns.push({
            title: (
              <>
                <p>R - Final</p>
                <p>{bidDates.finalBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPriceR`,
                key: `${vendorKey}UnitPriceR`,
                className: "vencolumn",
                width: 80,
                align: "right",
                render: (value, record) => {
                  // Hide unit price for summary rows (Basic Price and all after)
                  const summarySrNos = [
                    "A1",
                    "B1",
                    "C1",
                    "D1",
                    "E1",
                    "F1",
                    "H1",
                    "I1",
                    "K1",
                    "L",
                    "L1",
                    "M",
                    "M1",
                  ];
                  if (
                    summarySrNos.includes(record.srNo) ||
                    (typeof record.city === "string" &&
                      record.city.startsWith("Average Price"))
                  ) {
                    return "";
                  }
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}AmountR`,
                key: `${vendorKey}AmountR`,
                width: 80,
                align: "right",
                className: "vencolumn",
                render: (value, record) => {
                  if (record.city === "Commercial Ranking on Total Price") {
                    return (
                      <span>{(value && value !== "N/A" && value) || ""}</span>
                    );
                  } else {
                    return <span>{value || ""}</span>;
                  }
                },
              },
            ],
          });
        } else if (latest === "R1") {
          columns.push({
            title: (
              <>
                <p>R1 - Revised</p>
                <p>{bidDates.revisedBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPriceR1`,
                key: `${vendorKey}UnitPriceR1`,
                className: "vencolumn",
                align: "right",
                width: 80,
                render: (value, record) => {
                  // Hide unit price for summary rows (Basic Price and all after)
                  const summarySrNos = [
                    "A1",
                    "B1",
                    "C1",
                    "D1",
                    "E1",
                    "F1",
                    "H1",
                    "I1",
                    "K1",
                    "L",
                    "L1",
                    "M",
                    "M1",
                  ];
                  if (
                    summarySrNos.includes(record.srNo) ||
                    (typeof record.city === "string" &&
                      record.city.startsWith("Average Price"))
                  ) {
                    return "";
                  }
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}AmountR1`,
                key: `${vendorKey}AmountR1`,
                align: "right",
                className: "vencolumn",
                width: 80,
                render: (value, record) => {
                  if (record.city === "Commercial Ranking on Total Price") {
                    return (
                      <span>{(value && value !== "N/A" && value) || ""}</span>
                    );
                  } else {
                    return <span>{value || ""}</span>;
                  }
                },
              },
            ],
          });
        } else if (latest === "R0") {
          columns.push({
            title: (
              <>
                <p>R0 - Initial</p>
                <p>{bidDates.initialBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPriceR0`,
                key: `${vendorKey}UnitPriceR0`,
                className: "vencolumn",
                align: "right",
                width: 80,
                render: (value, record) => {
                  // Hide unit price for summary rows (Basic Price and all after)
                  const summarySrNos = [
                    "A1",
                    "B1",
                    "C1",
                    "D1",
                    "E1",
                    "F1",
                    "H1",
                    "I1",
                    "K1",
                    "L",
                    "L1",
                    "M",
                    "M1",
                  ];
                  if (
                    summarySrNos.includes(record.srNo) ||
                    (typeof record.city === "string" &&
                      record.city.startsWith("Average Price"))
                  ) {
                    return "";
                  }
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}AmountR0`,
                key: `${vendorKey}AmountR0`,
                align: "right",
                className: "vencolumn",
                width: 80,
                render: (value, record) => {
                  if (record.city === "Commercial Ranking on Total Price") {
                    return (
                      <span>{(value && value !== "N/A" && value) || ""}</span>
                    );
                  } else {
                    return <span>{value || ""}</span>;
                  }
                },
              },
            ],
          });
        }

        if (
          showR1 &&
          bidDates.revisedBidDate &&
          bidDates.revisedBidDate !== "N/A" &&
          latest !== "R1"
        ) {
          columns.push({
            title: (
              <>
                <p>R1 - Revised</p>
                <p>{bidDates.revisedBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPriceR1`,
                key: `${vendorKey}UnitPriceR1`,
                className: "vencolumn",
                align: "right",
                width: 80,
                render: (value, record) => {
                  // Hide unit price for summary rows (Basic Price and all after)
                  const summarySrNos = [
                    "A1",
                    "B1",
                    "C1",
                    "D1",
                    "E1",
                    "F1",
                    "H1",
                    "I1",
                    "K1",
                    "L",
                    "L1",
                    "M",
                    "M1",
                  ];
                  if (
                    summarySrNos.includes(record.srNo) ||
                    (typeof record.city === "string" &&
                      record.city.startsWith("Average Price"))
                  ) {
                    return "";
                  }
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "N/A";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}AmountR1`,
                key: `${vendorKey}AmountR1`,
                align: "right",
                className: "vencolumn",
                width: 80,
                render: (value, record) => {
                  if (record.city === "Commercial Ranking on Total Price") {
                    return (
                      <span>{(value && value !== "N/A" && value) || ""}</span>
                    );
                  } else {
                    return <span>{value || ""}</span>;
                  }
                },
              },
            ],
          });
        }

        if (
          showR0 &&
          bidDates.initialBidDate &&
          bidDates.initialBidDate !== "N/A" &&
          latest !== "R0"
        ) {
          columns.push({
            title: (
              <>
                <p>R0 - Initial</p>
                <p>{bidDates.initialBidDate}</p>
              </>
            ),
            className: "vencolumn",
            children: [
              {
                title: "Unit Price",
                dataIndex: `${vendorKey}UnitPriceR0`,
                key: `${vendorKey}UnitPriceR0`,
                className: "vencolumn",
                align: "right",
                width: 80,
                render: (value, record) => {
                  // Hide unit price for summary rows (Basic Price and all after)
                  const summarySrNos = [
                    "A1",
                    "B1",
                    "C1",
                    "D1",
                    "E1",
                    "F1",
                    "H1",
                    "I1",
                    "K1",
                    "L",
                    "L1",
                    "M",
                    "M1",
                  ];
                  if (
                    summarySrNos.includes(record.srNo) ||
                    (typeof record.city === "string" &&
                      record.city.startsWith("Average Price"))
                  ) {
                    return "";
                  }
                  if (record.isSummary) {
                    return "";
                  }
                  return value || "N/A";
                },
              },
              {
                title: "Basic Amount",
                dataIndex: `${vendorKey}AmountR0`,
                key: `${vendorKey}AmountR0`,
                align: "right",
                className: "vencolumn",
                width: 80,
                render: (value, record) => {
                  if (record.city === "Commercial Ranking on Total Price") {
                    return (
                      <span>{(value && value !== "N/A" && value) || ""}</span>
                    );
                  } else {
                    return <span>{value || ""}</span>;
                  }
                },
              },
            ],
          });
        }

        if (columns.length === 0) return [];
        return [
          {
            title: <span style={{ color: "#094E8F" }}>{vendorName}</span>,
            className: "vencolumn",
            children: columns,
          },
        ];
      })
    : [];

  const columns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      key: "srNo",
      width: 40,
      align: "center",
      render: (text, record) => {
        // Show peach badge for K1
        const isK1 = text === "K1";
        const bgColor = isK1 ? "#FFD3B3" : getColor(text);
        return (
          <span
            style={{
              backgroundColor: bgColor || "transparent",
              height: "25px",
              width: "25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "4px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: 30,
      render: (text, record, index) => {
        const a1Index = dataSource.findIndex((row) => row && row.srNo === "A1");
        const nextRow = dataSource[index + 1];
        if (a1Index !== -1 && index >= a1Index) {
          return {
            children: getCustomText(text, record),
            props: { colSpan: 2 },
          };
        } else {
          return {
            children: getCustomText(text, record),
            props: { colSpan: 1 },
          };
        }
      },
    },
    {
      title: "Sub Category",
      dataIndex: "subCategory",
      key: "subCategory",
      width: "80px",
      render: (text, record, index) => {
        const nextRow = dataSource[index + 1];

        const a1Index = dataSource.findIndex((row) => row.srNo === "A1");

        // if (index >= a1Index) {
        //   return {
        //     children: text,
        //     props: {
        //       colSpan: 0,
        //     },
        //   };
        // } else {
        return text;
        // }
      },
    },
    {
      title: "Grade & Quality",
      dataIndex: "materialType",
      key: "materialType",
      width: "80px",
      render: (text, record, index) => {

        const nextRow = dataSource[index + 1];

        const a1Index = dataSource.findIndex((row) => row.srNo === "A1");

        // if (index >= a1Index) {
        //   return {
        //     children: text,
        //     props: {
        //       colSpan: 0,
        //     },
        //   };
        // } else {
        return text;
        // }
      },
    },
    showGST && {
      title: (
        <>
          <p>GST</p>
          <p>(%)</p>
        </>
      ),
      dataIndex: "gst_rate",
      key: "gst_rate",
      width: 40,
      render: (text, record) => {
        // Only show GST when materialType is shown (i.e., when material changes)
        if (record.materialType) {
          return text;
        }
        return "";
      },
    },
    {
      title: "Site",
      dataIndex: "site",
      key: "site",
      width: 100,
      render: (text, record, index) => {
        const nextRow = dataSource[index + 1];

        const a1Index = dataSource.findIndex((row) => row.srNo === "A1");

        if (index >= a1Index) {
          return {
            children: text,
            props: {
              colSpan: 0,
            },
          };
        } else {
          return text;
        }
      },
    },
    {
      title: "Diameter",
      dataIndex: "diameter",
      key: "diameter",
      align: "center",
      width: 80,
    },

    {
      title: "Qty.",
      dataIndex: "qty",
      key: "qty",
      width: "40px",
      align: "center",
      render: (text, record, index) => {
        return text?.toLocaleString("en-IN", { maximumFractionDigits: 0 });
      },
    },
    {
      title: "UoM.",
      dataIndex: "uom",
      key: "uom",
      width: "40px",
      align: "center",
      render: (text, record) => {
        if (text === "Cubic Meter") {
          return "Cu. Mtr.";
        } else {
          return text;
        }
      },
    },
    showLPP && {
      title: "LPP (Last Purchase Price)",
      children: [
        {
          title: "Last order detail",
          children: [
            {
              title: "PO & Date",
              dataIndex: "poDate",
              key: "poDate",
              width: 90,
              render: (text, record) => {
                if (!text) return "";
                const [poNumber, date] = text.split(" - ");

                return (
                  <>
                    <p style={{ fontSize: "12px" }}>{poNumber}</p>
                    <p style={{ fontSize: "12px" }}>{date}</p>
                  </>
                );
              },
            },
            {
              title: "Vendor Name",
              dataIndex: "vendorName",
              key: "vendorName",
              width: 90,
            },
            {
              title: "Unit Price",
              dataIndex: "unitPrice",
              key: "unitPrice",
              width: 80,
              align: "right",
            },
          ],
        },
        {
          title: (
            <Tooltip
              color="#094E8F"
              placement="top"
              title="Last 30 Days Avg. Price"
            >
              30DAP{" "}
              <InfoCircleOutlined
                style={{ color: "#094E8F", marginLeft: "3px" }}
              />
            </Tooltip>
          ),
          width: 100,
          children: [
            { title: "", dataIndex: "avgPrice", key: "avgPrice", width: 100 },
          ],
        },
      ],
    },

    {
      title: (
        <Tooltip color="#094E8F" placement="top" title="Item wise L1">
          IWL1{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      children: [
        {
          title: "",
          dataIndex: "itemWiseL1",
          key: "itemWiseL1",
          width: "50px",
          align: "right",
          render: (text, record) => {
            return <strong>{text}</strong>;
          },
        },
      ],
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title="Last 30 Days CityWise Avg. Price on Smart Buyer"
        >
          30DAP{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      width: "80px",
      children: [
        {
          title: "",
          dataIndex: "cityWise",
          width: "40px",
          key: "cityWise",
          align: "right",
        },
      ],
    },
    ...venColumn,
  ].filter(Boolean);

  const hiddencolumns = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      key: "srNo",
      width: 40,
      align: "center",
      render: (text) => {
        const bgColor = getColor(text);
        return (
          <span
            style={{
              backgroundColor: bgColor || "transparent",
              height: "25px",
              width: "25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "4px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: 30,
      render: (text, record, index) => {
        const a1Index = dataSource.findIndex((row) => row.srNo === "A1");
        const nextRow = dataSource[index + 1];

        if (index >= a1Index) {
          return {
            children: getCustomText(text, record), // Apply tooltip-based rendering
            props: {
              colSpan: 2, // Merge if in "A1" range
            },
          };
        } else {
          return {
            children: getCustomText(text, record),
            props: {
              colSpan: 1,
            },
          };
        }
      },
    },

    {
      title: "Site",
      dataIndex: "siteName",
      key: "siteName",
      width: 20,
    },
    {
      title: "Items",
      dataIndex: "items",
      key: "items",
      width: 120,
      render: (text, record, index) => {
        const nextRow = dataSource[index + 1];

        const a1Index = dataSource.findIndex((row) => row.srNo === "A1");

        if (index >= a1Index) {
          return {
            children: text,
            props: {
              colSpan: 0,
            },
          };
        } else {
          return text;
        }
      },
    },
    {
      title: "Qty.",
      dataIndex: "qty",
      key: "qty",
      align: "center",
      // width: 40,
      width: "auto",
      render: (text, record, index) => {
        return text?.toLocaleString("en-IN", { maximumFractionDigits: 0 });
      },
    },
    {
      title: "UoM.",
      dataIndex: "uom",
      key: "uom",
      align: "center",
      // width: 40,
      width: "auto",
      render: (text, record) => {
        if (text === "Cubic Meter") {
          return "Cu. Mtr.";
        } else {
          return text;
        }
      },
    },
    {
      title: (
        <Tooltip color="#094E8F" placement="top" title="Item wise L1">
          IWL1{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      children: [
        {
          title: "",
          dataIndex: "itemWiseL1",
          key: "itemWiseL1",
          width: 100,
          align: "right",
        },
      ],
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title="Last 30 Days CityWise Avg. Price on Smart Buyer"
        >
          30DAP {""}{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      width: 80,
      children: [
        {
          title: "",
          dataIndex: "cityWise",
          width: 120,
          key: "cityWise",
          align: "right",
        },
      ],
    },
    // ...hiddenvenColumn,
  ].filter(Boolean);

  const hiddencolumns1 = [
    {
      title: "Sr.",
      dataIndex: "srNo",
      key: "srNo",
      width: 40,
      align: "center",
      render: (text, record) => {
        // Show peach badge for K1
        const isK1 = text === "K1";
        const bgColor = isK1 ? "#FFD3B3" : getColor(text);
        return (
          <span
            style={{
              backgroundColor: bgColor || "transparent",
              height: "25px",
              width: "25px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "4px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      width: 30,
      render: (text, record, index) => {
        const a1Index = dataSource.findIndex((row) => row && row.srNo === "A1");
        const nextRow = dataSource[index + 1];
        if (a1Index !== -1 && index >= a1Index) {
          return {
            children: getCustomText(text, record),
            props: { colSpan: 2 },
          };
        } else {
          return {
            children: getCustomText(text, record),
            props: { colSpan: 1 },
          };
        }
      },
    },
    {
      title: "Grade & Quality",
      dataIndex: "materialType",
      key: "materialType",
      width: "80px",
      render: (text, record, index) => {

        const nextRow = dataSource[index + 1];

        const a1Index = dataSource.findIndex((row) => row.srNo === "A1");

        // if (index >= a1Index) {
        //   return {
        //     children: text,
        //     props: {
        //       colSpan: 0,
        //     },
        //   };
        // } else {
        return text;
        // }
      },
    },
    showGST && {
      title: (
        <>
          <p>GST</p>
          <p>(%)</p>
        </>
      ),
      dataIndex: "gst_rate",
      key: "gst_rate",
      width: 40,
      render: (text, record) => {
        // Only show GST when materialType is shown (i.e., when material changes)
        if (record.materialType) {
          return text;
        }
        return "";
      },
    },
    {
      title: "Site",
      dataIndex: "site",
      key: "site",
      width: 100,
      render: (text, record, index) => {
        const nextRow = dataSource[index + 1];

        const a1Index = dataSource.findIndex((row) => row.srNo === "A1");

        if (index >= a1Index) {
          return {
            children: text,
            props: {
              colSpan: 0,
            },
          };
        } else {
          return text;
        }
      },
    },
    {
      title: "Diameter",
      dataIndex: "diameter",
      key: "diameter",
      align: "center",
      width: 80,
    },

    {
      title: "Qty.",
      dataIndex: "qty",
      key: "qty",
      width: "40px",
      align: "center",
      render: (text, record, index) => {
        return text?.toLocaleString("en-IN", { maximumFractionDigits: 0 });
      },
    },
    {
      title: "UoM.",
      dataIndex: "uom",
      key: "uom",
      width: "40px",
      align: "center",
      render: (text, record) => {
        if (text === "Cubic Meter") {
          return "Cu. Mtr.";
        } else {
          return text;
        }
      },
    },
    showLPP && {
      title: "LPP (Last Purchase Price)",
      children: [
        {
          title: "Last order detail",
          children: [
            {
              title: "PO & Date",
              dataIndex: "poDate",
              key: "poDate",
              width: 90,
              render: (text, record) => {
                if (!text) return "";
                const [poNumber, date] = text.split(" - ");

                return (
                  <>
                    <p style={{ fontSize: "12px" }}>{poNumber}</p>
                    <p style={{ fontSize: "12px" }}>{date}</p>
                  </>
                );
              },
            },
            {
              title: "Vendor Name",
              dataIndex: "vendorName",
              key: "vendorName",
              width: 90,
            },
            {
              title: "Unit Price",
              dataIndex: "unitPrice",
              key: "unitPrice",
              width: 80,
              align: "right",
            },
          ],
        },
        {
          title: (
            <Tooltip
              color="#094E8F"
              placement="top"
              title="Last 30 Days Avg. Price"
            >
              30DAP{" "}
              <InfoCircleOutlined
                style={{ color: "#094E8F", marginLeft: "3px" }}
              />
            </Tooltip>
          ),
          width: 100,
          children: [
            { title: "", dataIndex: "avgPrice", key: "avgPrice", width: 100 },
          ],
        },
      ],
    },

    {
      title: (
        <Tooltip color="#094E8F" placement="top" title="Item wise L1">
          IWL1{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      children: [
        {
          title: "",
          dataIndex: "itemWiseL1",
          key: "itemWiseL1",
          width: "50px",
          align: "right",
          render: (text, record) => {
            return <strong>{text}</strong>;
          },
        },
      ],
    },
    {
      title: (
        <Tooltip
          color="#094E8F"
          placement="top"
          title="Last 30 Days CityWise Avg. Price on Smart Buyer"
        >
          30DAP{" "}
          <InfoCircleOutlined style={{ color: "#094E8F", marginLeft: "3px" }} />
        </Tooltip>
      ),
      width: "80px",
      children: [
        {
          title: "",
          dataIndex: "cityWise",
          width: "40px",
          key: "cityWise",
          align: "right",
        },
      ],
    },
    ...venColumn,
  ].filter(Boolean);

  const columns3 = [
    { title: "Sr.", dataIndex: "srNo", key: "srNo" },
    { title: "", dataIndex: "title", key: "title" },
    ...summaryColumn,
  ];


  const menu = (
    <Menu className="downloadmenu">
      <Menu.ItemGroup
        key="pdf"
        title={
          <span style={{ fontWeight: "bold" }}>
            <img src={PDF} alt="PDF Icon" /> Download PDF
          </span>
        }
      >
        <Menu.Item key="pdf1" onClick={exportToExcel}>
          1.1 Download as per current view
        </Menu.Item>
      </Menu.ItemGroup>

      <Menu.ItemGroup
        key="excel"
        title={
          <span style={{ fontWeight: "bold" }}>
            <img src={Excel} alt="PDF Icon" />
            Download Excel
          </span>
        }
      >
        <DownloadTableExcel
          filename={`Comparative City Wise Statement-${rfqNumber}`}
          sheet="users"
          currentTableRef={tableRef.current}
        >
          <Menu.Item key="excel2">2.1. Download as per current view</Menu.Item>
        </DownloadTableExcel>

        <Menu.Item key="excel2">
          <DownloadTableExcel
            filename={`Comparative City Wise Statement-${rfqNumber}`}
            sheet="users"
            currentTableRef={hiddenTableRef.current}
          >
            2.2. Download all offers (BIDs)
          </DownloadTableExcel>
        </Menu.Item>
      </Menu.ItemGroup>
    </Menu>
  );

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Comparatives - Material Wise</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="">Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/request-for-quotation/history">RFQ History</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Comparative - Material Wise</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <h5 className="rfq-number new">
            RFQ Number :{" "}
            <span style={{ marginRight: "20px" }}>{rfqNumber}</span>
            Buyer : <span>{buyerName}</span>
          </h5>
          <div className="btnwrp2" style={{ alignItems: "center" }}>
            <h5 className="rfq-number new">Amount in INR</h5>
            <Dropdown overlay={menu} trigger={["hover"]} placement="bottom">
              <Button
                className="SaveGradiantBtn"
                type="primary"
                htmlType="PDF"
                label="PDF"
                icon={<img src={Downloadpd} alt="PDF Icon" />}
              >
                Download
              </Button>
            </Dropdown>

            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              // htmlType="Submit"
              label="View City Wise"
              onClick={() =>
                navigate(
                  `/request-for-quotation/comparatives-by-city-by-diameter/${id}`
                )
              }
            />
          </div>
        </div>
      </div>
      <div className="stepscontentwrap">
        <div className="stepsContent">
          <section className="grid-sec mt-5">
            <div className="PR-body" style={{ padding: "0" }}>
              <div
                className="rgq-num-wrap"
                style={{ flexWrap: "wrap", alignItems: "center" }}
              >
                <div className="bidleftfilters">
                  <Checkbox checked={showR0} onChange={handleCheckboxhideR0}>
                    Show Initial BID Price - R0
                  </Checkbox>
                  <Checkbox checked={showR1} onChange={handleCheckboxhideR1}>
                    Show Revise BID Price - R1
                  </Checkbox>
                  <Checkbox checked={showLPP} onChange={handleCheckboxhideLPP}>
                    Show Last Purchase Price
                  </Checkbox>
                  <Checkbox checked={showGST} onChange={handleCheckboxhideGST}>
                    Show GST %
                  </Checkbox>
                </div>
                <div
                  className="bidlRightfilters"
                  style={{ flexWrap: "nowrap" }}
                >
                  <label>City Wise Filter</label>
                  <Form.Item name="site_name" label="">
                    <Select
                      showArrow
                      mode="multiple"
                      showSearch
                      allowClear
                      placeholder="Select City"
                      optionFilterProp="children"
                      onChange={handleSiteNameSelectChange}
                      value={state.city_names}
                      style={{ width: "160px" }}
                    >
                      {cityName.map((item) => (
                        <Option key={item.id} value={item.name}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <label>Material Wise Filter</label>
                  <Form.Item name="material_type" label="">
                    <Select
                      showArrow
                      mode="multiple"
                      showSearch
                      allowClear
                      placeholder="Select Material"
                      optionFilterProp="children"
                      onChange={handleMaterialSelectChange}
                      value={state.material_type_names}
                      style={{ width: "200px" }}
                    >
                      {materialName.map((material) => (
                        <Option key={material.id} value={material.name}>
                          {material.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
              </div>

              <Spin spinning={apiLoading}>
                <div ref={tableRef}>
                  <Table
                    dataSource={dataSource}
                    bordered
                    scroll={{
                      x: "auto",
                    }}
                    columns={columns}
                    className="comparativecustomtbl"
                    pagination={false}
                  />
                </div>
              </Spin>
              <div className="footerTable">
                <Table
                  columns={columns3}
                  dataSource={summaryDataSource}
                  pagination={false}
                  bordered
                />
              </div>
            </div>
            <div ref={hiddenTableRef} style={{ display: "none" }}>
              <Table
                ref={hiddenTableRef}
                dataSource={dataSource}
                bordered
                scroll={{ x: "auto" }}
                columns={hiddencolumns1}
                className="comparativecustomtbl"
                pagination={false}
              />
            </div>
          </section>
        </div>
        <div
          className="FormFooter bidftr"
          style={{ padding: "16px  ", margin: "0" }}
        >
          <ButtonField
            className="SaveGradiantBtn"
            type="primary"
            // htmlType="Submit"
            label="Price Comparative Review"
            onClick={() =>
              navigate(
                `/request-for-quotation/summarypricecomparatives-by-diameter/${id}`
              )
            }
          />
        </div>
      </div>
    </>
  );
};

export default MaterialWiseComparativeByDiameter;
